import { createQuery } from '@tanstack/svelte-query';
import { fetchProjectFileFolders } from '$lib/api/project_file_folders';
import { resolveScope, getProjectScope, type ScopeFn } from './scope';

// Mirrors projectFilesQuery's scoping: unitScope, when given and non-nullish,
// scopes to that unit's folders; otherwise lists all project folders.
export const projectFileFoldersQuery = (
	scope: ScopeFn = getProjectScope(),
	unitScope?: () => number | undefined
) =>
	createQuery(() => {
		const projectId = resolveScope(scope);
		const unitId = unitScope?.();
		return {
			queryKey: ['project_file_folders', { projectId, unitId }],
			queryFn: () => fetchProjectFileFolders(projectId, unitId),
			enabled: projectId > 0
		};
	});
